import { Route } from '~/Constants/Routes.constants';
import { AccessListItem, AccessRoles as AR, FitogramVersion } from './accessList.types';

const allVersions = [FitogramVersion.Neo, FitogramVersion.PartnerTool];
const allRoles = [AR.ORGANISATION_MANAGER, AR.FULL_ACCESS, AR.RESTRICTED, AR.TRAINER];

// routes that only unlogged in users can access
export const PUBLIC_ROUTES = [
  Route.LOGIN,
  Route.LOGIN_USC,
  Route.RECOVER_PASSWORD,
  Route.RECOVER_PASSWORD_SUCCESS,
  Route.NEW_PASSWORD,
  Route.NEW_PASSWORD_SUCCESS,
  Route.ONBOARDING,
  Route.ONBOARDING_STUDIO,
  Route.ONBOARDING_DETAILS,
  Route.ONBOARDING_VERIFICATION,
];

// routes that everyone can reach.
const NO_NEED_FOR_ACCESS_ROUTES = [
  Route.HOME,
  Route.LOADING,
  Route.PROVIDER_ROOT,
  Route.PROVIDER_SELECT,
  Route.ONBOARDING_POSTLOGIN,
];
// default but needs access
const DEFAULT_ROUTES = [
  Route.PROVIDER_DETAIL,
  Route.USER_SETTINGS,
  Route.USER_SETTINGS_CHANGE_PASSWORD,
  Route.ACCOUNT_CONFIRMATION,
];

const CUSTOMER_GROUP = [Route.CUSTOMERS, Route.CUSTOMER_PROFILE, Route.CUSTOMER_CREATE];

const EVENT_GROUP = [
  Route.EVENTS,
  Route.EVENT_DETAILS,
  Route.EVENTGROUPS,
  Route.EVENT_CREATE,
  Route.EVENT_TYPE_CREATE,
  Route.EVENTGROUP_EDIT,
  Route.EVENT_EDIT,
];

const BOOKING_GROUP = [Route.CUSTOMER_ADD_PRODUCT, Route.BOOK_CUSTOMER];

const LOCATION_GROUP = [
  Route.PROVIDER_LOCATIONS,
  Route.PROVIDER_LOCATIONS_EDIT,
  Route.PROVIDER_LOCATIONS_EDIT_BASE,
];

const STAFF_GROUP = [Route.PROVIDER_STAFF, Route.PROVIDER_STAFF_CREATE, Route.PROVIDER_STAFF_EDIT];

const IMPORT_GROUP = [Route.IMPORT, Route.IMPORT_REVIEW, Route.IMPORT_COMPLETE];

export const ORGANISATION_GROUP = [
  Route.ORGANISATION_ROOT,
  Route.ORGANISATION_SELECT,
  Route.ORGANISATION_DETAIL,
  Route.ORGANISATION_SETTINGS,
  Route.ORGANISATION_STAFF,
  Route.ORGANISATION_STAFF_CREATE,
  Route.ORGANISATION_STAFF_UPDATE,
  Route.ORGANISATION_STUDIO,
  Route.ORGANISATION_MERCHANT,
  Route.ORGANISATION_MERCHANT_SETTING,
];

export const accessListRoutes: AccessListItem[] = [
  { names: NO_NEED_FOR_ACCESS_ROUTES, accessToOneOf: [], fitogramVersion: allVersions },
  {
    names: DEFAULT_ROUTES,
    accessToOneOf: allRoles,
    fitogramVersion: allVersions,
  },
  {
    names: CUSTOMER_GROUP,
    accessToOneOf: [AR.RESTRICTED, AR.ORGANISATION_MANAGER, AR.FULL_ACCESS],
    fitogramVersion: [FitogramVersion.Neo],
  },
  {
    names: EVENT_GROUP,
    accessToOneOf: allRoles,
    fitogramVersion: allVersions,
  },
  {
    names: BOOKING_GROUP,
    accessToOneOf: allRoles,
    fitogramVersion: allVersions,
  },
  {
    names: [
      Route.CALENDAR,
      Route.ACCEPT_REJECT_PUBLIC_API,
      Route.ACCEPT_REJECT_PUBLIC_API_WITH_PARAMS,
    ],
    accessToOneOf: allRoles,
    fitogramVersion: allVersions,
  },
  {
    names: STAFF_GROUP,
    accessToOneOf: [AR.ORGANISATION_MANAGER, AR.FULL_ACCESS],
    fitogramVersion: [FitogramVersion.PartnerTool],
  },
  {
    names: ORGANISATION_GROUP,
    accessToOneOf: [AR.FITOGRAM_SUPER_ADMIN, AR.PARTNER_TOOL_ADMIN, AR.ORGANISATION_MANAGER],
    fitogramVersion: allVersions,
  },
  {
    names: [Route.ATTENDANCE, ...LOCATION_GROUP],
    accessToOneOf: [AR.ORGANISATION_MANAGER, AR.FULL_ACCESS, AR.RESTRICTED, AR.PARTNER_TOOL_ADMIN],
    fitogramVersion: [FitogramVersion.PartnerTool],
  },
  {
    names: [Route.PAYOUTS],
    accessToOneOf: [AR.ORGANISATION_MANAGER, AR.FULL_ACCESS],
    fitogramVersion: [FitogramVersion.PartnerTool],
  },
  {
    names: [Route.PROVIDER_SETTINGS],
    accessToOneOf: [AR.ORGANISATION_MANAGER, AR.FULL_ACCESS],
    fitogramVersion: [FitogramVersion.PartnerTool],
  },
  {
    names: IMPORT_GROUP,
    accessToOneOf: [AR.FITOGRAM_SUPER_ADMIN],
    fitogramVersion: [FitogramVersion.Neo],
  },
  {
    names: [Route.ORGANISATION_STUDIO_CREATE, Route.PROVIDER_LOCATIONS_CREATE],
    accessToOneOf: [AR.FITOGRAM_SUPER_ADMIN, AR.PARTNER_TOOL_ADMIN],
    fitogramVersion: allVersions,
  },
  {
    names: [
      Route.INTEGRATIONS,
      Route.URBANSPORTSINTEGRATION,
      Route.THIRDPARTYINTEGRATION,
      Route.THIRDPARTYINTEGRATIONCREATE,
    ],
    accessToOneOf: [AR.FITOGRAM_SUPER_ADMIN, AR.PARTNER_TOOL_ADMIN],
    fitogramVersion: [FitogramVersion.PartnerTool],
  },
  {
    names: [Route.VIDEO_ON_DEMAND_ACTIVATE],
    accessToOneOf: [AR.FITOGRAM_SUPER_ADMIN, AR.PARTNER_TOOL_ADMIN],
    fitogramVersion: [FitogramVersion.PartnerTool],
  },
  {
    names: [Route.VIDEO_ON_DEMAND, Route.VIDEO_ON_DEMAND_CREATE, Route.VIDEO_ON_DEMAND_EDIT],
    accessToOneOf: [
      AR.FITOGRAM_SUPER_ADMIN,
      AR.PARTNER_TOOL_ADMIN,
      AR.ORGANISATION_MANAGER,
      AR.FULL_ACCESS,
    ],
    fitogramVersion: [FitogramVersion.PartnerTool],
  },
  {
    names: [Route.ONBOARDING_POSTLOGIN],
    accessToOneOf: [AR.FITOGRAM_SUPER_ADMIN, AR.PARTNER_TOOL_ADMIN],
    fitogramVersion: allVersions,
  },
  {
    names: [Route.EXPORT_PAGE, Route.BASE_EXPORT_ROUTE],
    accessToOneOf: [AR.FITOGRAM_SUPER_ADMIN, AR.PARTNER_TOOL_ADMIN],
    fitogramVersion: allVersions,
  },
];
